var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"w-fit group flex items-center rounded-2xl pl-4 py-1 text-sm bg-primary-50 dark:bg-darkblue-600 text-primary-800 m-1"},[_c('span',{staticClass:"mr-4 break-words"},[_vm._v(_vm._s(this.label)+" : "+_vm._s(this.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }